import { Box } from '@chakra-ui/react'
import React from 'react'
import AllTenure from '../../component/AllTenure'


const TenureGenerate = () => {
  // const [tData, setTData] = useState([]);
 

  // useEffect(() => {
  //   const fetchData = async () => {
  //     let response = await fetch('http://localhost:3000/tall');
  //     let data = await response.json();
  //     data = data.filter((d) => d.tenure_status === "ID Generated")
  //     setTData(data);
  //   }
  //   fetchData()
  // }, [])

  return (
    <Box p={5} flex="1" w={'100%'}>
      
      <AllTenure
        title={"Tenure Generated"}
        head={["Tenure ID", "Order Item", "Total Rent", "Tenure Type", "Billing Date", "Expiry Dtae", "Payment Status", "Tenure Status",""]}
        data={[]}
      />
    </Box>
  )
}

export default TenureGenerate
